// extracted by mini-css-extract-plugin
export var image = "_ip-1";
export var imageContainer = "_ip-0";